module.exports = __webpack_public_path__ + "static/media/whatsapp.78e59f67.svg";